const c = {
  name: "Bus",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,29c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C9.3,32,8,30.7,8,29z M11,28c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C12,28.4,11.6,28,11,28z"/>
		<path class="st0" d="M29,26c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C32,27.3,30.7,26,29,26z M28,29c0-0.6,0.4-1,1-1s1,0.4,1,1
			c0,0.6-0.4,1-1,1S28,29.6,28,29z"/>
		<path class="st0" d="M24,30h-8v-2h8V30z"/>
		<path class="st0" d="M36,18v15c0,1.7-1.3,3-3,3v4h-7v-4H14v4H7v-4c-1.7,0-3-1.3-3-3V18H2c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h2V3
			c0-1.7,1.3-3,3-3h26c1.7,0,3,1.3,3,3v3h1c1.7,0,3,1.3,3,3v6c0,1.7-1.3,3-3,3H36z M7,2C6.5,2,6,2.5,6,3v3h28V3c0-0.5-0.5-1-1-1H7z
			 M36,8v8h1c0.5,0,1-0.5,1-1V9c0-0.5-0.5-1-1-1H36z M34,8H21v14h13V8z M19,22V8H6v14H19z M34,24H6v9c0,0.5,0.5,1,1,1h26
			c0.5,0,1-0.5,1-1V24z M4,16V8H2v8H4z M28,36v2h3v-2H28z M9,36v2h3v-2H9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Bus
};
